import { I2087Form } from 'clickNgo/models/crud/forms'

import { CAMPAIGN_REMINDER_SEND_STATUS } from '../model/constants'
import { CampaignReminder } from '../model/types'

import { formatCampaignReminderSendAt } from './campaignReminderDate'

type CampaignReminderTo2087 = Omit<CampaignReminder, 'entryId' | 'sendStatus'> & {
  entryId?: CampaignReminder['entryId']
}

export const mapCampaignReminderTo2087 = ({
  entryId,
  campaignId,
  partnerId,
  sendAt,
  sendTo,
}: CampaignReminderTo2087): Partial<I2087Form> => ({
  ...(entryId ? { EntryId: entryId } : {}),
  CampaignId: campaignId,
  PartnerId: partnerId,
  SendAt: formatCampaignReminderSendAt(sendAt),
  SendStatus: CAMPAIGN_REMINDER_SEND_STATUS.PENDING,
  SendTo: sendTo,
})
